// 引入obs库
const hwyConfig = {
  hwyParams: {
    access_key_id: '7UHOH6QX14FHUFPXEXHZ',
    secret_access_key: 'BW9JJ6IKWmoKVj3RREhxunPrs7FrnVK47tBZuO9F',
    server: 'https://obs.cn-south-1.myhuaweicloud.com',
    // Bucket : 'evestemptation'
  },
  returnServe: 'https://chuanzhishang.obs.cn-south-1.myhuaweicloud.com/'
}

export default hwyConfig